<template>
    <footer class="container py-5">
        <div class="mb-5">
            <h3 class=" text-left">Discover Homes by Neighborhoods</h3>
            <p class="font2 text-left">Live among the hustle and bustle, embrace the city's energy</p>
        </div>

        <!-- Neighborhoods -->
        <div class="row">
            <div v-for="(state, index) in states"
                 :key="index"
                 class="col-6 col-md-4 col-lg-2 mb-4 fade-in-up"
                 :class="`delay-${index}`">
                <p class="state">{{ state.name }}</p>
                <div class="d-flex flex-column">
                    <a v-for="(area, idx) in state.areas"
                       :key="idx"
                       class="area-link"
                       :href="`/search/${area}/0/0`">
                        {{ area }}
                    </a>
                </div>
            </div>
        </div>

        <hr />

        <!-- Footer Links & App Buttons -->
        <!-- <div class="row align-items-start mb-4">
            <div class="col-12 col-md-4 store-buttons mb-4 mb-md-0">
                <h4 class="state">Download our app</h4>
                <p class="font2">Where the nation finds their home</p>
                <a href="#"><img src="@/assets/images/play-store.png" alt="Play Store" /></a>
                <a href="#"><img src="@/assets/images/app-store.png" alt="App Store" /></a>
            </div>

            <div class="col-6 col-md-2" v-for="(section, index) in footerSections" :key="index">
                <h5 class="state">{{ section.title }}</h5>
                <router-link
                    v-for="(link, i) in section.links"
                    :key="i"
                    :to="link.url"
                    class="area-link d-block">
                    {{ link.name }}
                </router-link>
            </div>
        </div>

        <hr /> -->

        <!-- Bottom Links -->
        <div class="d-flex flex-column justify-content-between align-items-center gap-2 text-center text-md-start mb-3 font2 ft-16 fw-normal text-black">
            <div class="d-flex gap-2 flex-wrap align-items-center justify-content-center bullet-links">
                <a v-for="(link, i) in bottomLinks" :key="i" class="footer-link position-relative">
                    {{ link }}
                </a>
            </div>

            <div class="d-flex align-items-center gap-3 social-icons font2 ft-16 fw-normal text-black">
                <img src="@/assets/images/web.svg" alt="Language" />
                <p class="mb-0">English (NG)</p>
                <a href="#"><img src="@/assets/images/instagram.svg" alt="Instagram" /></a>
                <a href="#"><img src="@/assets/images/facebook.svg" alt="Facebook" /></a>
                <a href="#"><img src="@/assets/images/twitter.svg" alt="Twitter" /></a>
            </div>
            <p class="text-center font2 ft-16 text-black fw-normal mb-0 mt-2">2025 Shelter Technologies LTD.</p>
        </div>

    </footer>
</template>

<script>
    export default {
        data() {
            return {
                states: [
                    { name: "Lagos", areas: ["Lekki", "Victoria Island", "Gbagada", "Yaba", "Ikoyi", "Surulere"] },
                    { name: "Abuja", areas: ["Maitama", "Gwarinpa", "Wuse", "Asokoro", "Jabi", "Utako"] },
                    { name: "Rivers", areas: ["Port Harcourt", "GRA Phase 2", "Obio-Akpor", "Rumuokoro", "Ogbunabali", "D-Line"] },
                    { name: "Oyo", areas: ["Bodija", "Jericho", "Dugbe", "Molete", "Apata", "Agodi"] },
                    { name: "Enugu", areas: ["Independence Layout", "GRA", "New Haven", "Achara Layout", "Trans-Ekulu", "Uwani"] },
                    { name: "Kano", areas: ["Nasarawa", "Sabon Gari", "Tarauni", "Gidan Murtala", "Kumbotso", "Fagge"] }
                ],
                footerSections: [
                    {
                        title: "Company",
                        links: [
                            { name: "About Us", url: "/about" },
                            { name: "Blog", url: "/" },
                            { name: "Careers", url: "/" },
                            { name: "Investors", url: "/" }
                        ]
                    },
                    {
                        title: "Support",
                        links: [
                            { name: "Help Center", url: "/" },
                            { name: "Rental Guide", url: "/" },
                            { name: "Contact Us", url: "/" }
                        ]
                    },
                    {
                        title: "Privacy",
                        links: [
                            { name: "Privacy Policy", url: "/privacy" },
                            { name: "Data Protection", url: "/" },
                            { name: "Terms and Conditions", url: "/terms" },
                            { name: "Cookie Policy", url: "/" }
                        ]
                    },
                    {
                        title: "Our Services",
                        links: [
                            { name: "List Your Properties", url: "/host/add-listing" },
                            { name: "Find a Home", url: "/search/all" },
                            { name: "Neighbourhood Guide", url: "/" }
                        ]
                    }
                ],
                bottomLinks: ["Privacy", "Terms", "About Us", "Contact"]
            };
        }
    };
</script>

<style scoped>
    footer {
        background-color: #fff;
        color: #333;
    }

    .state {
        font-family: 'CommunityGothicCond';
        font-size: 16px;
        font-weight: 600;
        margin-bottom: 0.5rem;
    }

    .area-link {
        color: #555;
        margin-bottom: 7px;
        transition: all 0.3s ease;
        text-decoration: none;
    }

        .area-link:hover {
            color: #007bff;
            transform: translateX(5px);
        }

    .fade-in-up {
        opacity: 0;
        transform: translateY(20px);
        animation: fadeInUp 0.6s ease forwards;
    }

    .delay-0 {
        animation-delay: 0s;
    }

    .delay-1 {
        animation-delay: 0.1s;
    }

    .delay-2 {
        animation-delay: 0.2s;
    }

    .delay-3 {
        animation-delay: 0.3s;
    }

    .delay-4 {
        animation-delay: 0.4s;
    }

    .delay-5 {
        animation-delay: 0.5s;
    }

    @keyframes fadeInUp {
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    a {
        display: block;
        margin-bottom: 6px;
        color: inherit;
        text-decoration: none;
    }

        a:hover {
            color: #007bff;
        }

    /* Bullet separator */
    .bullet-links a {
        position: relative;
        padding-right: 12px;
        margin-right: 6px;
    }

        .bullet-links a:not(:last-child)::after {
            content: '';
            position: absolute;
            right: 2px;
            top: 50%;
            transform: translateY(-50%);
            width: 4px;
            height: 4px;
            background-color: #888;
            border-radius: 50%;
        }

    /* App store icons hover */
    .store-buttons a img {
        width: 120px;
        height: auto;
        margin-right: 10px;
        transition: transform 0.3s ease, box-shadow 0.3s ease;
    }

        .store-buttons a img:hover {
            transform: translateY(-4px) scale(1.05);
            box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
        }

    /* Responsive social icons */
    .social-icons img {
        width: 24px;
        height: 24px;
        cursor: pointer;
    }

        .social-icons img:hover {
            transform: scale(1.1);
            transition: transform 0.3s ease;
        }
</style>
